import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Form from '../../components/react-validation/components/form';
import Multiselect from 'components/Multiselect';
import Input from '../../components/react-validation/components/input';
import Submit from '../../components/react-validation/components/submit';
import * as ProjectActionType from '../constants';
import shallowEqual from 'recompose/shallowEqual';
import Translate from 'components/translate';

class ProjectAddEditCoordinator extends Component {

  static propTypes = {
    projectId: PropTypes.string,
    dispatch: PropTypes.func,
    builderUserList: PropTypes.array,
    assignmentUserList: PropTypes.object,
    UserProfile: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.projectId = this.props.projectId;

    this.state = {
      selectedUser: [],
      builderUserList: [],
      isFetchingBuilderUser: false
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_PROJECT_ASSIGNMENT_USER_ASYNC,
      params: {
        projectId: this.projectId
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.builderUserList.length && !shallowEqual(nextProps.builderUserList, this.state.builderUserList)) {
      this.setState({
        builderUserList: nextProps.builderUserList
      });
    }

    if (nextProps.builderUserList) {
      this.setState({
        isFetchingBuilderUser: false
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: ProjectActionType.RESET_BUILDER_USER_LIST
    });
  }

  fetchBuilderUser = () => {
    this.setState({
      isFetchingBuilderUser: true
    }, () => {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_BUILDER_USER_ASYNC,
        params: {
          projectId: this.projectId,
          searchKey: '',
          selectedValue: ''
        }
      });
    });
  }

  onSelectUser = (value) => {
    this.setState({
      selectedUser: value
    });
  }

  renderValue = option => {
    return option.displayName;
  }

  renderOptions = (builderUserList) => {
    if (builderUserList.length) {
      if (this.props.UserProfile.sso) {
        let systemUsers = [];
        let builderUsers = [];

        builderUserList.map((item) => {
          if (item.extensionValue.sso) {
            systemUsers.push({
              label: item.text + ' (' + item.extensionValue.email + ')',
              value: item.value,
              displayName: item.text
            });
          } else {
            builderUsers.push({
              label: item.text + ' (' + item.extensionValue.email + ')',
              value: item.value,
              displayName: item.text
            });
          }
        });

        let options = [
          {
            label: 'System users',
            options: systemUsers.length ? systemUsers : ['empty']
          },
          {
            label: 'Builder users',
            options: builderUsers.length ? builderUsers : ['empty']
          }
        ];

        return options;
      } else {
        return builderUserList.map((item) => ({
          label: item.text + ' (' + item.extensionValue.email + ')',
          value: item.value,
          displayName: item.text
        }));
      }
    } else {
      return [];
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    let userIdList = [];
    this.state.selectedUser.map(item => userIdList.push(item.value));
    this.props.dispatch({
      type: ProjectActionType.ASSIGN_USER_TO_PROJECT_ASYNC,
      params: {
        projectId: this.projectId,
        param: {
          userIds: userIdList
        }
      }
    });
    this.setState({selectedUser: []});
  }

  render() {
    return (
      <div className='box-form-body'>
        <div className='box-form-project-coordinator'>
          <div className='multi-select-user-wrapper col-sm-3'>
            <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit}>
              <div className='form-group'>
                <Input type='hidden' name='projectId' ref='projectId' value={this.projectId} />
                <label>Builder users <span className='text-danger'>*</span></label>
                <Multiselect
                  placeholder='--Please select'
                  items={this.renderOptions(this.state.builderUserList)}
                  value={this.state.selectedUser}
                  onChange={this.onSelectUser}
                  valueRenderer={this.renderValue}
                  onRemote={this.fetchBuilderUser}
                  isLoading={this.state.isFetchingBuilderUser}
                  errorMessage='This information is required.'
                  ref={ref => {
                    this.multiSelect = ref;
                  }}
                />
              </div>
              <div className='form-group'>
                <Submit className='btn btn-primary btn-submit btn-siteone' disabled={!this.state.selectedUser.length}>Assign</Submit>
              </div>
            </Form>
          </div>

          <div className='list-user-wrapper col-sm-9'>
            <p className='numOfItem'>{this.props.assignmentUserList && this.props.assignmentUserList.totalRecord ? this.props.assignmentUserList.totalRecord + ' items' : '0 item'}</p>
            <ul>
              <label>Name</label>
              {this.props.assignmentUserList && this.props.assignmentUserList.items &&
                this.props.assignmentUserList.items.length
                ? this.props.assignmentUserList.items.map((item) => {
                  if (item.isProductOwner) {
                    return <li className='col-sm-12' key={item.id}>
                      <span className='col-sm-6' style={{paddingLeft: 0}}>{item.displayName + ' (' + item.email + ')'}</span>
                      <div className='col-sm-6 text-right'><span className='pill-indicators locked'><Translate translateKey='project' capitalize /> owner</span></div>
                    </li>;
                  }
                  return <li className='col-sm-12' key={item.id}>{item.displayName + ' (' + item.email + ')'}</li>;
                }) : <li>No data found.</li>
              }
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    builderUserList: state.ProjectStore.BuilderUserList,
    assignmentUserList: state.ProjectStore.AssignmentUserList,
    UserProfile: state.UserStore.UserProfile
  };
};

export default connect(mapStateToProps)(ProjectAddEditCoordinator);



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-coordinator.js